import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import {
    BadgeComponent,
    BadgeVariant,
    ButtonComponent,
    ClientDataSource,
    ColumnType,
    TableComponent,
    TableFormat
} from "@sxm-content-creators/tools-ds";
import { AuthService } from "../../../../auth/auth.service";
import { User } from "../../models/user.model";
import { UserApiService } from "../../services/user.api.service";

@Component({
    selector: "app-users",
    templateUrl: "./users.component.html",
    styleUrl: "./users.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [BadgeComponent, ButtonComponent, RouterLink, TableComponent]
})
export class UsersComponent implements OnInit {
    private readonly userService = inject(UserApiService);
    private readonly authService = inject(AuthService);
    private readonly destroyRef = inject(DestroyRef);

    readonly currentUserEmail = signal<string | null>(null);
    readonly dataSource = new ClientDataSource<User>();
    readonly BadgeVariant = BadgeVariant;

    readonly tableFormat: TableFormat = {
        headers: [{ name: "Name" }, { name: "Email" }, { name: "Role" }, { name: "" }],
        columns: [
            { type: ColumnType.CUSTOM },
            { type: ColumnType.TEXT, firstLine: "email" },
            { type: ColumnType.TEXT, firstLine: "role" },
            { type: ColumnType.CUSTOM, showChildTemplate: "edit-action" }
        ]
    };

    ngOnInit(): void {
        this.userService
            .getUsers()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
                this.dataSource.data = response.users;
            });

        this.authService
            .getCurrentUserEmail()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(email => {
                this.currentUserEmail.set(email);
            });
    }
}
